import { couple, venue } from '@/mocks/wedding';
import { copyText } from '@/lib/share';
import { useToast } from '@/components/wedding/ToastProvider';

const COVER =
  'https://static.readdy.ai/image/cc733f6f6e0d1f78a0bfb68c2c846ad3/750cb8afdd06f0a6e2e07c0a03424542.jpeg';

export default function ClosingSection() {
  const toast = useToast();

  const shareText = `${couple.groom.name} · ${couple.bride.name} 결혼합니다
${couple.weddingDate} ${couple.weddingTime}
${venue.name} ${venue.hall}
${venue.address}`;

  const handleCopyLink = async () => {
    const ok = await copyText(window.location.href);
    toast.show(ok ? '청첩장 링크를 복사했어요' : '복사에 실패했어요. 주소창의 링크를 복사해 주세요');
  };

  return (
    <footer className="closing" id="closing">
      <img className="closing-bg" src={COVER} alt="나무 테이블 위에 놓인 웨딩 사진" data-parallax="0.28" />
      <div className="closing-veil" aria-hidden="true" />

      <p className="stamp" data-reveal>
        10 — 마지막 인사
      </p>
      <p className="closing-line" data-reveal>
        참석해 주시는 마음,
        <br />
        오래도록 <em className="accent">기억</em>하겠습니다
      </p>
      <p className="sub" data-reveal style={{ maxWidth: '34ch' }}>
        바쁜 걸음에도 함께해 주시는 모든 분께 진심으로 감사드립니다.
      </p>
      <p className="closing-names" data-reveal>
        김도윤 · 이서연
      </p>
      <p className="closing-date" data-reveal>
        {couple.dateShort} SAT · 오후 1시
      </p>

      <div className="share-row" data-reveal>
        <a className="cta" href={`sms:?body=${encodeURIComponent(shareText)}`}>
          <i className="ri-message-3-line" aria-hidden="true" />
          문자로 공유하기
        </a>
        <button type="button" className="ghost-btn" onClick={handleCopyLink}>
          <i className="ri-link" aria-hidden="true" />
          링크 복사
        </button>
      </div>

      <div className="site-foot">
        <p>© 2026 김도윤 · 이서연 모바일 청첩장 · 템플릿으로 제작되었습니다</p>
        <div className="foot-links">
          <a href="#top">처음으로</a>
          <a href="#rsvp">참석 여부</a>
          <a href="#guestbook">방명록</a>
          <a href="#ceremony">예식 정보</a>
        </div>
      </div>
    </footer>
  );
}